<template>
	<el-dialog 
		:lang="$i18n.locale" 
		:title="dialogTitle" 
		:visible.sync="visible" 
		:close-on-click-modal="false" 
		width="980px"
		:append-to-body="true" 
		@close="handleDialogClose"
	>
		<el-form label-width="150px" :model="dialogForm" ref="OrderForm" :rules="rules" :inline="true">
			<el-form-item :label="$t('commonInfo.orderType')" prop="order_category">
				<el-select v-model="dialogForm.order_category" filterable :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.orderType')" :disabled="isEdit" style="width: 650px;">
					<el-option v-for="item in order_categoryList" :key="item.dictCode" :label="item.dictLabel"
						:value="item.dictValue"></el-option>
				</el-select>
			</el-form-item>
			<div v-if="dialogForm.order_category == 'OWH'">
			  <!-- 自提不需要显示仓库和地址，默认飞坦海外仓，需要填写联系人和联系方式 -->
			  <el-form-item :label="$t('commonInfo.deliveryMode')" prop="deliveryType">
			  	<el-radio v-model="dialogForm.deliveryType" label="1">{{$t('commonInfo.homeDeliveryService')}}</el-radio>
			  	<el-radio v-model="dialogForm.deliveryType" label="2">{{$t('commonInfo.whSelfPickup')}}</el-radio>
			  </el-form-item>
			</div>
			<div v-if="dialogForm.order_category != ''">
				<el-form-item v-if="dialogForm.order_category != 'DS'" :label="$t('commonInfo.warhouseCode')" prop="receiver_address">
					<el-tag v-if="dialogForm.deliveryType == '2'" type="success">{{$t('commonInfo.fleetanWarehouse')}}</el-tag>
					<el-select v-else v-model="dialogForm.receiver_address" filterable :placeholder="$t('tipsInfo.selectPlaceholder') + $t('commonInfo.deliveryWarehouse')" style="width: 650px;">
						<el-option v-for="item in selectWhList" :key="item.dictCode" :label="item.dictLabel"
							:value="item.dictValue"></el-option>
					</el-select>
				</el-form-item>
				<CustomerAddressSelector :visible="dialogForm.order_category == 'OWH' && dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom'" country="SA" @select="applyCustomerAddress" />
				<!-- OWH 送货上门 自定义仓库需要填写地址详情 -->
				<el-form-item v-if="dialogForm.receiver_address == 'custom' || dialogForm.deliveryType == '2'"  :label="$t('commonInfo.deliveryDest')" prop="receiver_detail_address">
    				<el-input style="width: 650px;" v-model="dialogForm.receiver_detail_address" :disabled="dialogForm.deliveryType == '2'"
    					:placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.deliveryDest')"></el-input>
    			</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'OWH' && dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom'"
    				label="目的城市" prop="destCity">
    				<el-select v-model="dialogForm.destCity" filterable
    					:placeholder="$t('tipsInfo.selectPlaceholder') + '目的城市'"
    					style="width: 650px;">
    					<el-option v-for="item in saCityList" :key="item.dictCode" :label="item.dictLabel"
    						:value="item.dictLabel"></el-option>
    				</el-select>
    			</el-form-item>
				<el-form-item v-if="dialogForm.deliveryType == '2' || (dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom')" :label="dialogForm.deliveryType == '1'?$t('commonInfo.contactMan'):$t('commonInfo.consigneeTypeOne')" prop="contacts">
					<el-input v-model="dialogForm.contacts" clearable style="width: 650px;"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.deliveryType == '2' || (dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom')" :label="dialogForm.deliveryType == '1'?$t('commonInfo.contact'):$t('commonInfo.consigneeContact')" prop="contactsTel">
					<el-input v-model="dialogForm.contactsTel" clearable style="width: 650px;"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'FBA'" :label="$t('commonInfo.fbaNo')" prop="fba_no">
					<el-input v-model="dialogForm.fba_no" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.fbaNo')"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'FBA'" :label="$t('commonInfo.fbaNoCode')" prop="fbaNoCode">
					<el-input v-model="dialogForm.fbaNoCode" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.fbaNoCode')"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'FBN'" :label="$t('commonInfo.asnNo')" prop="fba_no">
					<el-input v-model="dialogForm.fba_no" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.asnNo')"></el-input>
				</el-form-item>
				<!-- FBN 订单类型需要填写店铺ID -->
				<el-form-item v-if="dialogForm.order_category == 'FBN' || dialogForm.order_category == 'DS'" :label="'NOON ' + $t('commonInfo.companyId')" prop="send_company">
					<el-input v-model="dialogForm.send_company" style="width: 650px;"></el-input>
				</el-form-item>
				<!-- OWH类型暂无法知道怎么填写该必传字段，先显示测试 -->
				<el-form-item v-if="dialogForm.order_category == 'OWH'" :label="$t('commonInfo.clientDeliveryNo')" prop="fba_no">
					<el-input v-model="dialogForm.fba_no" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.clientDeliveryNo')"></el-input>
				</el-form-item>
			</div>
			<div v-if="dialogForm.order_category != ''">
				<el-form-item v-if="dialogForm.order_category != 'FBA'" :label="dialogForm.deliveryType == '1'?$t('commonInfo.deliveryDate'):$t('commonInfo.pickupDate') + '(SA)'" prop="delivery_date">
					<el-date-picker
					  clearable
					  style="width: 650px;"
						popper-class="no-atTheMoment"
					  v-model="dialogForm.delivery_date"
						:picker-options="deliveryPickerOptions"
					  :type="dialogForm.order_category == 'OWH'?'date':'datetime'"
					  value-format="yyyy-MM-dd HH:mm:ss"
					  :placeholder="dialogForm.deliveryType == '1'?$t('tipsInfo.selectPlaceholder') + $t('commonInfo.deliveryDate'):$t('tipsInfo.selectPlaceholder') + $t('commonInfo.pickupDate')"
					></el-date-picker>
				</el-form-item>
				<!-- 预约送仓时间提示 -->
				<div class="deliveryTip" v-if="dialogForm.order_category != 'FBA' && !(dialogForm.order_category == 'OWH' && dialogForm.deliveryType == '2')">
					<h4><i class="el-icon-warning"></i>预约送仓时间选择规则：</h4>
					<span>1、选择送仓时间为沙特时间</span>
					<span>2、每周五沙特公休</span>
					<span>3、国内推单当天时间0点-15点为正常推单，</span>
					<label>15点到20点为加急推单，需要收取加急费用，</label>
					<label>20点过后不能推当天单</label>
					<span>4、提前一天以上为正常推单</span>
				</div>
				<!-- <el-form-item :label="$t('commonInfo.expectedDeliveryQuantity')" prop="clientAppointCount">
				<el-input v-model="dialogForm.clientAppointCount" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" style="width: 650px;"></el-input>
			</el-form-item> -->
			<!-- 是否更新箱唛 -->
			<el-form-item v-if="dialogForm.order_category == 'FBA'" label="是否更新箱唛" prop="isNeedNewLabel" required>
				<el-radio v-model="dialogForm.isNeedNewLabel" :label="true">是</el-radio>
				<el-radio v-model="dialogForm.isNeedNewLabel" :label="false">否</el-radio>	
			</el-form-item>
			<el-form-item :label="'SKU是否换标'" prop="isNeedSkuNewLabel">
				<el-radio v-model="dialogForm.isNeedSkuNewLabel" :label="true">是</el-radio>
				<el-radio v-model="dialogForm.isNeedSkuNewLabel" :label="false">否</el-radio>
			</el-form-item>
			<el-form-item v-if="['FBA', 'FBN', 'OWH'].includes(dialogForm.order_category)"
                label="PCS数量" prop="pcsCount" :required="dialogForm.order_category === 'FBA'">
                <el-input v-model.trim="dialogForm.pcsCount" style="width: 650px;" clearable
                    placeholder="所有箱内的商品总件数，非箱数或换标数量；FBA必填，其他选填"></el-input>
            </el-form-item>
			<el-form-item :label="$t('commonInfo.remark')" prop="exp">
				<el-input type="textarea" v-model="dialogForm.exp" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.remark')"></el-input>
			</el-form-item>
			</div>
		</el-form>
		<el-divider><i class="el-icon-box"></i></el-divider>
		<el-tabs v-model="activeTab" type="" style="margin:10px 15px;">
			<el-tab-pane label="箱信息" name="cartonInfo">
				<el-form  :inline="true" label-width="auto" style="margin:10px 0 0 0">
					<el-form-item>
						<el-button type="primary" icon="el-icon-plus" @click="handleAddCarton">{{$t('commonInfo.addBtn')}}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button @click="handleDeleteAll">{{$t('commonInfo.deleteAllBtn')}}</el-button>
					</el-form-item>
				</el-form>
				<el-table style="margin:5px 0;width: 100%" ref="cartonTable"
					v-loading="inventoryLoading" :data="paginatedCartonList" :cell-style="cellStyle" border 
					show-summary :summary-method="getSummaries"
					>
					<el-table-column :label="$t('commonInfo.orderNoColumn')" min-width="160" align="center" prop="orderNo" />
					<el-table-column :label="$t('commonInfo.packageNo')" min-width="160" align="center" prop="packageNo" />
					<el-table-column label="客户清关方式" min-width="120" align="center" prop="clientOperationType">
						<template slot-scope="{ row }">
							<span>{{ returnClientOperationType(row.clientOperationType) }}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('commonInfo.operationColumn')" align="center" prop="">
							<template slot-scope="{ row }">
								<el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(row.id)">{{$t('commonInfo.deleteBtn')}}</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div style="margin-top: 15px; text-align: right;">
					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  :current-page="currentPage"
					  :page-sizes="[10, 20, 30, 50]"
					  :page-size="pageSize"
					  layout="total, sizes, prev, pager, next, jumper"
					  :total="cartonList.length"
					></el-pagination>
					</div>
			</el-tab-pane>
			<el-tab-pane label="SKU换标" name="skuSwap" :disabled="!dialogForm.isNeedSkuNewLabel">
				<el-form  :inline="true" label-width="auto" >
					<el-form-item>
						<el-button type="primary" icon="el-icon-plus" size="small" @click="handleAddSkuSwap">{{$t('commonInfo.addBtn')}}</el-button>
					</el-form-item>
					<el-form-item>
				<el-upload
				  class="upload-demo"
				  :action="$baseUrl + '/toborder/wms/product/addMultiFbxStockProductCarton'"
				  :before-upload="beforeUpload"
				  :on-success="handlesuccess"
				  :on-error="handleError"
				  :on-progress="handleProgress"
				  multiple
				  :show-file-list="false"
				  :file-list="fileList"
				  accept=".xls, .xlsx"
				  :headers="headers"
				  name="productFile"
				  style="margin-right:5px"
				>
				  <el-button size="small" type="success">批量导入SKU换标信息</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item>
				<el-button size="small" @click="handleDownloadUrl">{{$t('commonInfo.downloadTemplate')}}</el-button>
			</el-form-item>
					<el-form-item>
						<el-button size="small" @click="handleDeleteAllSkuSwap">{{$t('commonInfo.deleteAllBtn')}}</el-button>
					</el-form-item>
				</el-form>
				<el-table style="margin:5px 0;width: 100%" ref="skuSwapTable"
				v-loading="skuSwapLoading" :data="skuSwapData" border 
				show-summary :summary-method="getSkuSwapSummaries"
				:cell-style="skuSwapCellStyle"
				>
					<el-table-column :label="$t('commonInfo.clientProductCode')" min-width="150" align="center" prop="sku_old">
						<template slot-scope="{ row }">
							<el-input v-model="row.sku_old" size="small" placeholder="请输入原SKU" />
						</template>
					</el-table-column>
					<el-table-column :label="$t('ksaWhFBXOrderPage.newLabelCode')" min-width="150" align="center" prop="sku_new">
						<template slot-scope="{ row }">
							<el-input v-model="row.sku_new" size="small" placeholder="请输入新SKU" />
						</template>
					</el-table-column>
					<el-table-column :label="$t('ksaWhFBXOrderPage.newLabelQuantity')" min-width="120" align="center" prop="swap_cnt">
						<template slot-scope="{ row }">
							<el-input v-model.number="row.swap_cnt" size="small" placeholder="请输入换标数量" />
						</template>
					</el-table-column>
					<el-table-column label="备注" min-width="180" align="center" prop="remarks">
						<template slot-scope="{ row }">
							<el-input v-model="row.remarks" size="small" placeholder="SKU所在的订单号或箱号" />
						</template>
					</el-table-column>
					<el-table-column :label="$t('commonInfo.operationColumn')" min-width="120" align="center" prop="">
						<template slot-scope="{ row }">
							<el-button size="mini" type="text" icon="el-icon-delete" @click="handleDeleteSkuSwap(row.sku_old)">{{$t('commonInfo.deleteBtn')}}</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
		</el-tabs>
		<div v-if="!isEdit" style="margin: 10px 0 0 0; display: inline-block;">
			<!-- 上传FBX附件 -->
			<SingleUploadPDF
			  v-if="dialogForm.order_category == 'FBA'"
			  v-model="fbxFlienName"
				:tipText="$t('commonInfo.labelFileTips')"
				:preFile="fbxPreName"
			  @input="getFBXInfo"
				class="fileUploadBtn"
			></SingleUploadPDF>
			<!-- 上传FBN 送仓文件 -->
			<SingleUploadPDF
			  v-if="dialogForm.order_category == 'FBN'"
			  v-model="labelFlienName"
				:tipText="labelTipText"
				:preFile="labelPreName"
			  @input="getLabelInfo"
				class="fileUploadBtn"
			></SingleUploadPDF>
			<!-- 当用户选择SKU换标时，显示上传换标附件按钮 -->
			<MutipleUploadNoLimit 
			  v-if="dialogForm.isNeedSkuNewLabel == true"
			  :tipText="$t('commonInfo.newLabelFileNolimitTips')"
				:isClearList.sync="clearFileListFlag"
			  @input="getNewLabelExcel"
			  class="fileUploadBtn"
			></MutipleUploadNoLimit>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleDialogClose" :disabled="submitLoading">{{$t('commonInfo.dialogBtnCancel')}}</el-button>
			<el-button v-if="isEdit" :disabled="submitLoading" type="danger" @click="handleDel()">{{$t('commonInfo.delete')}}</el-button>
			<el-button type="primary" :loading="submitLoading" @click="submit" :disabled="!openBtn || submitLoading">{{submitLoading?$t('commonInfo.dialogBtnSubmiting'):$t('commonInfo.dialogBtnSubmit')}}</el-button>
		</div>

		<!-- 导入Excel后错误的对话框 -->
		<el-dialog :lang="$i18n.locale" :title="$t('commonInfo.productInfo')" :visible.sync="dialogErrorVisible" width="640px" :close-on-click-modal="false">
		  <el-table :data="errorData">
		    <el-table-column property="sku_old" :label="$t('commonInfo.clientProductCode')" align="center"></el-table-column>
				<el-table-column property="count" :label="$t('commonInfo.orderQuantity')" align="center"></el-table-column>
				<el-table-column property="errorMsg" :label="$t('commonInfo.result')" align="center">
				</el-table-column>
		  </el-table>
		</el-dialog>
		<el-image-viewer v-if="showImg" :on-close="closeImg" :url-list="imgList" style="z-index: 9999;"/>
		<ChooseOrderCarton 
			:visible.sync="chooseOrderCartonVisible"
			@submit="handleChooseOrderCartonSubmit"
		/>
	</el-dialog>
</template>

<script>
import SingleUploadPDF from "@/components/upload/singleUploadPDF";
import MutipleUploadNoLimit from "@/components/upload/mutipleUploadNoLimit";
import MultiFunctionalUpload from "@/components/upload/multiFunctionalUpload";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import ChooseOrderCarton from "./chooseOrderCarton";
import CustomerAddressSelector from "@/components/customerAddress/CustomerAddressSelector";
import { formatDate, findDuplicates } from "@/utils/index";

export default {
	name: 'KSACreateCartonOrder',
	components: {
		SingleUploadPDF,
		MutipleUploadNoLimit,
		MultiFunctionalUpload,
		ElImageViewer,
		ChooseOrderCarton,
		CustomerAddressSelector
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	data() {
			return {
				dialogTitle: '创建整箱类型订单',
				dialogForm: {
					order_category: '',
					deliveryType: '1',
					receiver_address: '',
					receiver_detail_address: '',
					fba_no: '',
					fbaNoCode: '',
					send_company: '',
					delivery_date: '',
					clientAppointCount: '',
					pcsCount: '',
					isNeedNewLabel: false,
					isNeedSkuNewLabel: false,
					exp: '',
					contacts: '',
					contactsTel: '',
					skuListLink: '',
					label_url: '',
					newLabelLinkList: [],
					order_box_mark: '',
					destCity: '',
					packageNoList: [],
					productList: [],
				},
				order_categoryList: [
					{
						dictCode: '1',
						dictLabel: 'FBA',
						dictValue: 'FBA'
					},
					{
						dictCode: '2',
						dictLabel: 'FBN',
						dictValue: 'FBN'
					},
					{
						dictCode: '4',
						dictLabel: 'OWH',
						dictValue: 'OWH'
					}
				],
				saCityList: [],
				saCityLoading: false,
				cartonList: [],
			    // 分页相关
			    currentPage: 1,
			    pageSize: 10,
				selectWhList: [],
				deliveryPlatformList: [],
				isEdit: false,
				submitLoading: false,
				openBtn: true,
				hasSkuNewItem: false,
				searchProductCode: '',
				inventoryData: [],
				inventoryLoading: false,
				inventoryParams: {
					page: 1,
					limit: 10
				},
				fileList: [],
				headers: {},
				imgList: [],
				showImg: false,
				errorData: [],
				dialogErrorVisible: false,
				fbxFlienName: '',
				fbxLink: '',
				fbxPreName: [],
				labelFlienName: '',
				labelLink: '',
				labelPreName: [],
				labelTipText: '',
				newLabelFileLink: [],
				clearFileListFlag: false,
				clientCreateOrderSkuNum: 0,
				clientCreateOrderSwapNum: 0,
				orderProductList: [],
				skuModelUrl: '',
				uploadloading: false,
				oldFbaNo: '',
				deliveryPickerOptions: {
					disabledDate(time) {
						let nowDate = Date.now();
						let nowHour = new Date().getHours();
						if(nowHour < 15) {
							nowDate = nowDate - 24 * 60 * 60 * 1000;
						} else if(nowHour >= 15 && nowHour < 20) {
							nowDate = nowDate - 24 * 60 * 60 * 1000;
						}
						let nowDay = new Date(time).getDay();
						return nowDate > time.getTime() || nowDay == 5;
					},
					selectableRange: '10:00:00 - 18:00:00'
				},
				chooseOrderCartonVisible: false,
				activeTab: 'cartonInfo',
				skuSwapData: [],
				skuSwapLoading: false
			};
		},
	computed: {
		// 分页后的数据
		paginatedCartonList() {
			const startIndex = (this.currentPage - 1) * this.pageSize;
			const endIndex = startIndex + this.pageSize;
			return this.cartonList.slice(startIndex, endIndex);
		},
		rules() {
			const validateCode = (rule, value, callback) => {
				let reg = /[^\w\.\/]/ig;
				if(reg.test(value)) {
					callback(new Error(this.$t('commonInfo.numberAndLetterLimit')));
				} else {
					callback();
				}
			};
			return {
				order_category: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + this.$t('commonInfo.orderType'),
					trigger: 'blur'
				}],
                pcsCount: [{
                    validator: (rule, value, callback) => {
                        const text = value == null ? '' : String(value).trim();
                        if (!text) {
                            return callback(this.dialogForm.order_category === 'FBA' ? new Error('请填写PCS数量') : undefined);
                        }
                        if (!/^[0-9]+$/.test(text) || Number(text) <= 0 || Number(text) > 2147483647) {
                            return callback(new Error('PCS数量必须为正整数，且不能超过2147483647'));
                        }
                        callback();
                    },
                    trigger: 'blur'
                }],
				fba_no: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + this.$t('tipsInfo.info'),
					trigger: 'blur'
				}, {
					validator: validateCode,
					trigger: 'blur'
				}],
				fbaNoCode: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + this.$t('commonInfo.fbaNoCode'),
					trigger: 'blur'
				}, {
					min: 8,
					max: 8,
					message: this.$t('commonInfo.fbaNoCodeLimit'),
					trigger: 'change'
				}, {
					validator: validateCode,
					trigger: 'blur'
				}],
				delivery_date: [{
					required: true,
					message: this.dialogForm.deliveryType == '1' ? this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.deliveryDate') : this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.pickupDate'),
					trigger: 'blur'
				}],
				receiver_address: [{
					required: true,
					message: this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.warhouseCode'),
					trigger: 'blur'
				}],
				receiver_detail_address: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + this.$t('commonInfo.warhouseDetailAddress'),
					trigger: 'blur'
				}],
				// clientAppointCount: [{
				// 	required: true,
				// 	message: this.$t('tipsInfo.inputPlaceholder'),
				// 	trigger: 'blur'
				// }],
				send_company: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + 'NOON ' + this.$t('commonInfo.companyId'),
					trigger: 'blur'
				}, {
					min: 5,
					max: 6,
					message: this.$t('commonInfo.companyLimit'),
					trigger: 'blur'
				}],
				deliveryType: [{
					required: true,
					message: this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.deliveryMode'),
					trigger: 'blur'
				}],
				contacts: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + (this.dialogForm.deliveryType == '1' ? this.$t('commonInfo.contactMan') : this.$t('commonInfo.consigneeTypeOne')),
					trigger: 'blur'
				}],
				contactsTel: [{
				required: true,
				message: this.$t('tipsInfo.inputPlaceholder') + (this.dialogForm.deliveryType == '1' ? this.$t('commonInfo.contactMan') : this.$t('commonInfo.consigneeContact')),
				trigger: 'blur'
			}],
			isNeedNewLabel: [{
				required: true,
				message: '请选择是否更新箱唛',
				trigger: 'blur'
			}],
			isNeedSkuNewLabel: [{
				required: true,
				message: '请选择SKU是否换标',
				trigger: 'blur'
			}],
			destCity: [{
				required: true,
				message: '请选择目的地城市',
				trigger: 'blur'
			}],
			};
		}
	},
	watch: {
		'dialogForm.order_category': {
			immediate: true,
			handler(val) {
				this.dialogForm.receiver_address = '';
				this.selectWhList = [];
				this.dialogForm.deliveryType = '1';
				this.dialogForm.contacts = '';
				this.dialogForm.contactsTel = '';
				if (val != '' && val != null) {
					this.getWhDict(val);
				}
			}
		},
		'dialogForm.deliveryType': {
			immediate: true,
			handler(val) {
				this.dialogForm.contacts = '';
				this.dialogForm.contactsTel = '';
				if (val == '2') {
					this.dialogForm.receiver_address = 'Fleetan';
					// 获取fleetan海外仓信息
		            this.getWhDict('Fleetan');
				} else {
					this.dialogForm.receiver_address = '';
					this.getWhDict(this.dialogForm.order_category);
				}
			}
		},
		'dialogForm.receiver_address': {
			immediate: true,
			handler(val) {
				if (val != '' && val != null) {
					this.getWhInfo(val);
				}
			}
		},
		'dialogForm.delivery_date': function(newVal, oldVal) {
			if (!newVal) {
				return;
			}
			let nowDate = new Date();
			let chooseDate = new Date(newVal);
			let updateTime = '';
			if (this.isToday(chooseDate, nowDate)) {
				if (nowDate.getHours() < 15) {
					updateTime = '10:00:00 - 18:00:00';
				} else {
					updateTime = this.getTodayFirstSelectableHour(nowDate) + ':00:00 - 18:00:00';
				}
			} else {
				updateTime = '10:00:00 - 18:00:00';
			}
			this.$set(this.deliveryPickerOptions, 'selectableRange', updateTime);
			if ((this.dialogForm.order_category == 'FBA' || this.dialogForm.order_category == 'FBN') && this.isToday(chooseDate, nowDate) && chooseDate.getHours() < this.getTodayFirstSelectableHour(nowDate)) {
				this.dialogForm.delivery_date = newVal.split(' ')[0] + ' ' + this.getTodayFirstSelectableHour(nowDate) + ':00:00';
			}
		}
	},
	methods: {
		applyCustomerAddress(address) {
			this.dialogForm.destCity = address.city;
			this.dialogForm.receiver_detail_address = address.detailAddress;
			this.dialogForm.contacts = address.contactPerson;
			this.dialogForm.contactsTel = address.contactPhone;
		},
			isToday(date, nowDate = new Date()) {
				return date.getFullYear() == nowDate.getFullYear() && date.getMonth() == nowDate.getMonth() && date.getDate() == nowDate.getDate();
			},
			getTodayFirstSelectableHour(nowDate = new Date()) {
				return Math.min(15, Math.max(10, nowDate.getHours() - 4));
			},
			handleDialogClose() {
				this.$emit('update:visible', false);
				this.cancel();
			},
			closeImg() {
				this.showImg = false;
			},
			handleViewImg(img) {
				this.imgList = [];
				if(img.indexOf(',') == -1){
					this.imgList.push(img[0])
				}else{
					this.imgList = img.split(',');
				}
				this.showImg = true;
			},
			handleAddCarton() {
				this.chooseOrderCartonVisible = true;
			},
			handleDownloadUrl() {
				window.open(this.skuModelUrl);
			},
			handleDeleteAll() {
				this.$confirm(this.$t('tipsInfo.deleteAllRowTips'), this.$t('tipsInfo.warning'), {
						confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
						cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
						type: "warning"
					}
					).then(() => {
						this.cartonList = [];
						// 执行删除全部操作将上传文件地址清空
						this.dialogForm.skuListLink = '';
					})
					.catch(() => {});
			},
			returnClientOperationType(type) {
				switch (String(type)) {
					case '1':
						return 'COU';
					case '2':
						return 'CARGO';
					default:
						return '';
				}
			},
			isAirCouCarton(row) {
				return row && row.transportType === '100' && String(row.clientOperationType) === '1';
			},
			handleDelete(id) {
				let that = this;
				const row = this.cartonList.find(item => item.id === id);
				const confirmMessage = this.isAirCouCarton(row)
					? '该空运订单为COU，不能挑箱派送。确认删除该箱会将该订单所有箱删除，是否继续？'
					: this.$t('tipsInfo.deleteRowTips');
				this.$confirm(confirmMessage, this.$t('tipsInfo.warning'), {
						confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
						cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
						type: "warning"
					})
					.then(() => {
						if (this.isAirCouCarton(row)) {
							this.cartonList = this.cartonList.filter(item => {
								return !(item.orderNo === row.orderNo && this.isAirCouCarton(item));
							});
							this.$message.success(this.$t('tipsInfo.deleteSuccessTips'));
							return;
						}
						// 精准查找要删除的箱数据
						var index = this.cartonList.findIndex(item => item.id === id);
						if (index !== -1) {
							this.cartonList.splice(index, 1);
							this.$message.success(this.$t('tipsInfo.deleteSuccessTips'));
						} else {
							this.$message.error('未找到要删除的箱数据');
						}
					})
					.catch(() => {});
			},
			getWhDict(type) {
				let dictText = '';
				switch (type) {
					case 'FBA':
						dictText = 'sys_SA_FBAWh';
						break;
					case 'FBN':
						dictText = 'sys_SA_NOONWh';
						this.labelTipText = this.$t('commonInfo.deliveryFileTips');
						break;
					case 'OWH':
						dictText = 'sys_SA_OtherWh';
						break;
					// 自提 仓库信息默认fleetan海外仓
			        case 'Fleetan':
    			        dictText = 'sys_SA_FleetanWh';
    			        break;
				}
				this.$http.get("/toborder/system/dict/data/list?dictType=" + dictText).then(res => {
					if (res.code == 200) {
						this.selectWhList = res.rows;
						if(type == 'OWH'){
							// 2026-03-26 zpy 放开客户端自定义仓库选择
							// this.selectWhList = this.selectWhList.filter(item => {
							// 	return item.dictValue != 'custom';
							// })
						}
						if (type == 'Fleetan') {// 如果为自提类型，默认上传固定仓库信息，不需要显示
						    let address = this.selectWhList[0].remark.split('###')[0];
						    let city = this.selectWhList[0].remark.split('###')[3];
        				    this.dialogForm.receiver_detail_address = address;
						    this.dialogForm.destCity = city;
        			    }
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {
					this.$message.error(err.msg);
				})
			},
			getWhInfo(val) {
				let that = this;
				setTimeout(function() {
					that.selectWhList.forEach(item => {
						if(val == 'custom'){
							// 自定义仓库清空详细地址 和联系人信息
							that.dialogForm.receiver_detail_address = '';
							that.dialogForm.contacts = '';
							that.dialogForm.contactsTel = '';
							that.getSaCityList();
						}else if (item.dictValue == val) {
						    if (item.dictValue == val) {
							let address = '', whCity = '';
							if(item.remark && item.remark.includes('&&&')){
								address = item.remark.split('&&&')[0];
								whCity = item.remark.split('&&&')[1];
							}else{
								address = item.remark;
							}
							that.dialogForm.receiver_detail_address = address;
							that.dialogForm.destCity = whCity;
						}
						}
					})
				}, 300)
			},
			// 获取沙特城市列表
			async getSaCityList() {
				if (this.saCityList.length > 0 || this.saCityLoading) {
					return;
				}
				this.saCityLoading = true;
				// 获取B2B空运城市地址 sys_b2bAirCity_list
				try {
					const cityRes = await this.$http.get("/toborder/system/dict/data/list", {
						params: { page: 1, limit: 100, dictType: 'sys_b2bAirCity_list' }
					});
					if (cityRes.code === 200) {
						this.saCityList = cityRes.rows;
					} else {
						this.$message.error(cityRes.msg);
					}
				} finally {
					this.saCityLoading = false;
				}
			    
			},
			getFBXInfo(data) {
				this.fbxLink = data;
				if(data != ''){
					//修改upload的preview预览
					let str = data.split("~");
					this.fbxPreName = [{
						name:str[1],
						url:data,
					}]
				}
			},
			getLabelInfo(data) {
				this.labelLink = data;
				if(data != ''){
					//修改upload的preview预览
					let str = data.split("~");
					this.labelPreName = [{
						name:str[1],
						url:data,
					}]
				}
			},
			getNewLabelExcel(data) {
				this.newLabelFileLink = [];
				if(data.length > 0){
					data.forEach(item => {
						this.newLabelFileLink.push(item.url);
					})
				}
			},
			handleChooseOrderCartonSubmit(selectedCartons) {
				console.log(selectedCartons);
				if(selectedCartons.length > 0){
					this.cartonList.push(...selectedCartons);
					// 重置分页到第一页
					this.currentPage = 1;
				}
				// 去重
				this.cartonList = this.quchong(this.cartonList,'packageNo');
			},
			getSummaries(param) {
				const { columns, data } = param;
				const sums = [];
				// 计算总订单数（去重）- 基于所有数据
				const uniqueOrders = [...new Set(this.cartonList.map(item => item.orderNo))];
				const orderCount = uniqueOrders.length;
				// 计算总箱数 - 基于所有数据
				const cartonCount = this.cartonList.length;
				
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '合计';
						return;
					} else if (index === 1) {
						sums[index] = `总订单数：${orderCount}`;
						return;
					} else if (index === 2) {
						sums[index] = `总箱数：${cartonCount}`;
						return;
					} else {
						sums[index] = '';
					}
				});
				return sums;
			},
			cellStyle({ row, column, rowIndex, columnIndex }) {
				if (row['isError'] == true) {
					return {
						background: 'burlywood'
					};
				}
			},
			submit() {
				console.log(this.dialogForm.productList);
				if(this.dialogForm.order_category == 'FBA'){
					if(this.fbxLink == '' || this.fbxLink == null){
						this.$message.warning(this.$t('tipsInfo.submitOrderDeliveryMarkTips'));
						return; 
					}
				}
				if(this.dialogForm.order_category == 'FBN'){
					if(this.labelLink == '' || this.labelLink == null){
						this.$message.warning(this.$t('ksaWhFBXOrderPage.uploadPreTips') + this.labelTipText.split('-')[0]);
						return; 
					}
				}
			if(this.dialogForm.isNeedSkuNewLabel == true){
				if(this.skuSwapData.length == 0){
					this.$message.warning('请添加SKU换标数据');
					return; 
				}
				// 校验SKU换标数据
				const ruleInt = /^\+?[1-9][0-9]*$/;
				let hasError = false;
				this.skuSwapData.forEach(item => {
					item.isError = false;
					// 校验三个输入框都不能为空
					if(!item.sku_old || !item.sku_new || !item.swap_cnt){
						item.isError = true;
						hasError = true;
					}
					// 校验换标数量只能填写不为零的整数
					if(item.swap_cnt && !ruleInt.test(item.swap_cnt)){
						item.isError = true;
						hasError = true;
					}
				});
				if(hasError){
					this.$message.warning('请检查SKU换标数据是否填写规范');
					this.activeTab = 'skuSwap'; // 切换到SKU换标选项卡
					return;
				}
				if(this.newLabelFileLink.length == 0){
					this.$message.warning(this.$t('ksaWhFBXOrderPage.uploadPreTips') + this.$t('commonInfo.newLabelFile'));
					return; 
				}
				if(this.skuSwapData.length > 10){
					this.$message.warning('单个订单SKU超过10个，不支持换标');
					return; 
				}
				this.dialogForm.productList = this.skuSwapData;
			}
			    
			    // 获取整箱数据
				if(this.cartonList.length == 0){
					this.$message.warning('请选择订单整箱');
					return; 
				}
				if(this.dialogForm.order_category == 'OWH'){
					let deliveryDate = new Date(this.dialogForm.delivery_date);
					let hour = this.isToday(deliveryDate) ? this.getTodayFirstSelectableHour() : 10;
					this.dialogForm.delivery_date = this.dialogForm.delivery_date.split(' ')[0] + ' ' + hour + ':00:00';
				}
				// 获取箱号
				this.dialogForm.packageNoList = this.cartonList.map(item => item.packageNo);
				// 暂时将期望送仓数量设置为订单整箱数量
				this.dialogForm.clientAppointCount = this.cartonList.length;
				this.dialogForm.order_box_mark = this.fbxLink;
				this.dialogForm.label_url = this.labelLink;
				this.dialogForm.newLabelLinkList = this.newLabelFileLink;
				let url = '/toborder/wms/fulfillment/addByCarton';
				this.$refs["OrderForm"].validate(valid => {
					if(valid){
						let isUrgent = false;
						let nowDate = new Date();
						let chooseDate = new Date(this.dialogForm.delivery_date);
						if(nowDate.getDate() == chooseDate.getDate() && nowDate.getHours() > 15){
							isUrgent = true;
						}
						if(this.cartonList.length == parseInt(this.dialogForm.clientAppointCount)){
							if(isUrgent){
								this.$confirm(
										"<p style='color:#ff6868;font-weight:bold;'>"+ this.$t('ksaWhFBXOrderPage.urgentOrderTip') +"</p>" +
										 '<p>'+this.$t('ksaWhFBXOrderPage.confirmToCreateOrderTips')+'</p>',
										  this.$t('tipsInfo.tip'), {
											dangerouslyUseHTMLString: true,
											confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
											cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
											type: "warning"
										}
									).then(() => {
										this.submitOrderInfo(url);
									})
									.catch(() => {});
							}else{
								this.submitOrderInfo(url);
							}
						}else{
							let str = '';
							if(isUrgent){
								str = this.$t('ksaWhFBXOrderPage.urgentOrderTip');
							}
							this.$confirm(
								"<p style='color:#ff6868;font-weight:bold;'>"+ str +"</p>" +
								"<p>"+ this.$t('ksaWhFBXOrderPage.orderCountDiffTips') +"</p>" +
								 '<p>'+this.$t('ksaWhFBXOrderPage.orderCountTips')+'：<span style="color:red;">'+ this.clientCreateOrderSkuNum +'</span></p>' +
								 '<p>'+this.$t('commonInfo.expectedDeliveryQuantity')+'：<span style="color:red;">' + this.dialogForm.clientAppointCount + '</span></p>' +
								 '<p>'+this.$t('ksaWhFBXOrderPage.confirmToCreateOrderTips')+'</p>',
								  this.$t('tipsInfo.tip'), {
									dangerouslyUseHTMLString: true,
									confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
									cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
									type: "warning"
								}
								).then(() => {
									this.submitOrderInfo(url);
								})
								.catch(() => {});
						}
					}
				})
			},
			handleDel() {
				this.$confirm(
						this.$t('ksaWhFBXOrderPage.deleteOrderTips'),
						this.$t('tipsInfo.warning'), {
							confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
							cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
							type: "warning"
						}
					).then(() => {
						this.$http
							.post("/toborder/wms/fulfillment/del", {
								fbaOrderIds: [this.dialogForm.customer_order_no],
							})
							.then(res => {
								if (res.code === 200) {
									this.$message.success(this.$t('tipsInfo.deleteSuccessTips'));
									this.$emit('update:visible', false);
									this.$emit('refreshList');
								} else {
									this.$message.error(res.msg);
								}
							});
					})
					.catch(() => {});
			},
			submitOrderInfo(url) {
				this.submitLoading = true;
				const orderData = {
					...this.dialogForm,
					isNeedNewLabel: this.dialogForm.isNeedNewLabel ? '1' : '0',
					isNeedSkuNewLabel: this.dialogForm.isNeedSkuNewLabel ? '1' : '0'
				};
				this.$http.post(url, orderData).then(res => {
					if (res.code == 200) {
						this.$message.success(this.$t('tipsInfo.success'));
						this.submitLoading = false;
						this.$emit('update:visible', false);
						this.$emit('refreshList');
					} else {
						this.submitLoading = false;
						let msg = res.msg;
						if(res.data && res.data.length > 0){
							msg = res.data.map(item => {
								const orderNo = item.orderNo ? item.orderNo + '：' : '';
								return orderNo + (item.errorMsg || '当前不可放货');
							}).join('\n');
						}
						this.$alert(msg, '扣放货校验未通过', {
							confirmButtonText: '知道了',
							customClass: 'release-block-alert'
						});
					}
				}).catch(error => {
					this.submitLoading = false;
					this.$message.error(error.msg);
				})
			},
			cancel() {
				this.dialogForm = {
					order_category:'',
					skuListLink:'',
					label_url:'',
					newLabelLinkList:[],
					fba_no: '',
					delivery_date: '',
					receiver_address: '',
					receiver_detail_address: '',
					productList: [],
					clientAppointCount:'',
                    pcsCount: '',
					send_company:'',
					exp:'',
					deliveryType:'1',
					contacts:'',
					contactsTel:'',
					destCity:'',
					isNeedNewLabel: false,
					isNeedSkuNewLabel: false,	
					packageNoList: [],
				};
				this.activeTab = 'cartonInfo';
				this.clientCreateOrderSkuNum = 0;
				this.clientCreateOrderSwapNum = 0;
				this.newLabelFileLink = [];
				this.clearFileListFlag = true;
				this.hasSkuNewItem = false;
				this.inventoryData = [];
				this.orderProductList = [];
				this.searchProductCode = '';
				this.fbxLink = '';
				this.fbxFlienName = '';
				this.fbxPreName = [];
				this.labelLink = '';
				this.labelFlienName = '';
				this.labelPreName = [];
				this.skuSwapData = [];
				this.cartonList = [];
				let that = this;
				setTimeout(function(){
					that.clearFileListFlag = false;
				},100)
			},
			getModelUrl() {
				this.$http.get("/toborder/system/dict/data/list", {
					params: {
						page: 1,
						limit: 10,
						dictType: 'sys_template_url'
					}
				}).then(res => {
					if (res.code === 200) {
						let data = res.rows;
						data.forEach(item => {
							if(item.dictLabel == 'fulfillment FBX-Carton履单SKU换标模板'){
								this.skuModelUrl = item.remark;
							}
						});
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {
					this.$message.error(err.msg);
				})
			},
			quchong(arr,label) {
				const map = new Map();
				return arr.filter(item => {
					if (!map.has(item[label])) {
						map.set(item[label], true); // set返回set结构本身
						return true;
					}
					return false;
				});
			},
			handleAddSkuSwap() {
				// 添加一条数据到表格最前面
				const newItem = {
					sku_old: '',
					sku_new: '',
					swap_cnt: '',
					remarks: ''
				};
				this.skuSwapData.unshift(newItem);
			},
			handleDeleteAllSkuSwap() {
				// 删除所有数据
				this.$confirm(this.$t('tipsInfo.deleteAllRowTips'), this.$t('tipsInfo.warning'), {
					confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
					cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
					type: "warning"
				}).then(() => {
					this.skuSwapData = [];
				}).catch(() => {});
			},
			handleDeleteSkuSwap(code) {
				// 删除单条数据
				let that = this;
				this.$confirm(this.$t('tipsInfo.deleteRowTips'), this.$t('tipsInfo.warning'), {
					confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
					cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
					type: "warning"
				}).then(() => {
					var index = this.skuSwapData.findIndex(item => {
						if(item.sku_old == code){
							return true;
						}
					});
					this.skuSwapData.splice(index, 1);
					this.$message.success(this.$t('tipsInfo.deleteSuccessTips'));
				}).catch(() => {});
			},
			getSkuSwapSummaries(param) {
				// 统计换标数量
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '合计';
						return;
					}
					if (column.label == this.$t('ksaWhFBXOrderPage.newLabelQuantity')) {
						let swapSum = 0;
						data.map(item => {
							let swapValue = item.swap_cnt;
							if (swapValue == null || swapValue == undefined) {
								swapValue = 0;
							}
							swapSum += Number(swapValue);
						});
						sums[index] = swapSum == 0 ? '' : swapSum;
					} else {
						sums[index] = '';
					}
				});
				return sums;
			},
			skuSwapCellStyle({ row, column, rowIndex, columnIndex }) {
				if (row['isError'] == true) {
					return {
						background: 'burlywood'
					};
				}
			},
			beforeUpload(file) {
				let fileNameStr = file.name;
				if(fileNameStr.length > 30){
					return this.$message.warning(this.$t('tipsInfo.uploadFileNameLimitTips'));
				}
				var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
				const extension = testmsg === "xls";
				const extension2 = testmsg === "xlsx";
				if (!extension && !extension2) {
					this.$message.warning(
						this.$t('tipsInfo.uploadExcelTypeTips')
					);
				}
				return extension || extension2;
			},
			handlesuccess(files, fileList) {
				this.uploadloading = false;
				if (files.code == 200) {
					let that = this;
					if(files.data.productErrorInfoList.length == 0){
						this.$message.warning('解析文件失败，请检查文件');
					}else{
						if(!files.data.success){
							this.errorData = files.data.productErrorInfoList;
							this.dialogErrorVisible = true;
						}else{
							that.$message.success(this.$t('tipsInfo.uploadSuccess'));
							// 处理数据 获取返回数据的某些字段
							files.data.productErrorInfoList.forEach(item => {
							    this.skuSwapData.push({
									sku_old: item.clientProductCode,
									sku_new: item.skuNew,
									swap_cnt: item.swapCnt,
									remarks: item.remarks,
								});
							})
						}
					}
				} else if (files.code == 500) {
					this.$message.error(files.msg);
				}
				if (files.code == 401) {
					this.$message.error(this.$t('tipsInfo.loginOutTips'));
					window.sessionStorage.removeItem("token");
					return this.$router.push({
						path: "/login"
					});
				}
			},
			handleError(err, file, fileList) {
				this.uploadloading = false;
			},
			// 分页事件处理
			handleSizeChange(size) {
				this.pageSize = size;
				this.currentPage = 1; // 重置到第一页
			},
			handleCurrentChange(current) {
				this.currentPage = current;
			},
			handleProgress(event, file, fileList) {
				this.uploadloading = true;
			},
		},
		created() {
			let token = window.sessionStorage.getItem("token");
			this.headers = {
				Authorization: token,
			};
			this.getModelUrl();
		},
};
</script>

<style scoped>
.deliveryTip {
	width: 630px;
	margin-left: 150px;
	margin-bottom: 10px;
	background-color: #fffdd6;
	border-radius: 4px;
	padding: 5px 10px;
}

.deliveryTip h4 {
	margin: 0;
	line-height: 30px;
}

.deliveryTip i {
	margin: 0 5px;
}

.deliveryTip span {
	display: block;
	height: 20px;
	line-height: 20px;
	text-indent: 20px;
}

.deliveryTip label {
	display: block;
	height: 20px;
	line-height: 20px;
	text-indent: 40px;
	font-weight: bold;
}

.fileUploadBtn {
	float: left;
	margin: 0 10px;
	max-width: 220px;
}

.dialog-footer {
	text-align: center;
}

/* 阿拉伯语样式 */
[lang="ar"] {
	.deliveryTip {
		margin-left: 0;
		margin-right: 150px;
	}
	
	.fileUploadBtn {
		float: right;
		margin: 0 10px;
		max-width: 220px;
	}
	
	::v-deep .el-dialog__headerbtn {
		right: auto;
		left: 20px;
	}
	
	::v-deep .el-dialog__footer {
		text-align: left;
		.el-button {
			margin: 0 10px;
		}
	}
}
</style>

<style>
.release-block-alert .el-message-box__message p {
	white-space: pre-line;
}
</style>
